// BlogPage.js
import React, { useState, useEffect } from "react";
import WWD from "..//media/wwd.png";
const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [expandedPost, setExpandedPost] = useState(null);

  useEffect(() => {
    // Simulating fetching data from an API
    const fetchPosts = async () => {
      const fakePosts = [
        {
          id: 1,
          title: "🌍 World Water Day | A Drop of Hope",
          content:
            "In a small temple town where the Yamuna flows with sacred serenity, a young boy named Gopal walked 2 kilometers every morning just to fetch a bucket of clean water for his family. For him, water was not just a necessity—it was a prayer, a gift, and a lifeline. One morning, tired but smiling, Gopal saw a new water packet lying at his doorstep, labeled 'NGO Waters – Born for Charity.' Confused yet curious, he learned it was donated by a local company working to make clean water accessible to everyone—especially those who need it the most. That single packet was more than water. It was hope.",
          date: "22, March 2025",
          image: WWD,
          writer: "Hariom Singh",
        },
      ];
      setPosts(fakePosts);
    };
    fetchPosts();
  }, []);

  const handleReadMore = (id) => {
    setExpandedPost(expandedPost === id ? null : id);
  };

  const handleShare = (post) => {
    const blogUrl = `https://yourwebsite.com/blog/${post.id}`; // Replace with the actual blog post URL pattern
    const shareMessage = `Check out this blog post:

Title: ${post.title}
Date: ${new Date(post.date).toDateString()}
Writer: ${post.writer}

Read more: ${blogUrl}`;

    const shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      shareMessage
    )}`;
    window.open(shareUrl, "_blank");
  };

  return (
    <div className="container my-5">
      <h1
        className="text-center mb-4"
        style={{ fontWeight: "bold", color: "#333", fontSize: "2.5rem" }}
      >
        Latest Blogs
      </h1>
      <div className="row g-4">
        {posts.map((post) => (
          <div key={post.id} className="col-md-6 d-flex">
            <div className="card shadow-lg border-0 h-100 overflow-hidden">
              <img
                src={post.image}
                alt={post.title}
                className="card-img-top img-fluid"
                style={{ maxHeight: "250px", objectFit: "cover" }}
              />
              <div className="card-body d-flex flex-column">
                <h2 className="h5 text-dark" style={{ fontWeight: "600" }}>
                  {post.title}
                </h2>
                <p
                  className="text-muted small mb-2"
                  style={{ fontStyle: "italic" }}
                >
                  {new Date(post.date).toDateString()} | Written by{" "}
                  {post.writer}
                </p>
                <p
                  className="text-secondary flex-grow-1"
                  style={{ lineHeight: "1.6" }}
                >
                  {expandedPost === post.id
                    ? post.content
                    : `${post.content.substring(0, 100)}...`}
                </p>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    style={{ borderRadius: "20px", padding: "5px 20px" }}
                    onClick={() => handleReadMore(post.id)}
                  >
                    {expandedPost === post.id ? "Read Less" : "Read More"}
                  </button>
                  <button
                    className="btn btn-outline-success btn-sm d-flex align-items-center"
                    style={{ borderRadius: "20px" }}
                    onClick={() => handleShare(post)}
                  >
                    <i
                      className="bi bi-whatsapp me-2"
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                    Share
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
